import React, { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

const Newsletter: React.FC = () => {
  const [email, setEmail] = useState<string>('');

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    // Handle newsletter signup
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left Column - Newsletter Form */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
              Newsletter
            </h2>
            <p className="text-gray-700 mb-8">
              Inscrivez-vous pour un accès anticipé aux nouvelles marques, et tout spécialement toutes nos promotions, événements...
            </p>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                  placeholder="votre@email.com"
                  required
                />
              </div>

              <button
                type="submit"
                className="w-full bg-gray-700 text-white px-8 py-3 rounded-lg hover:bg-black transition-colors duration-300 font-medium"
              >
                S'inscrire à la newsletter
              </button>
            </form>
          </div>

          {/* Right Column - Site Links */}
          <div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
              <div>
                <h3 className="font-semibold text-black mb-4">Services</h3>
                <ul className="space-y-2 text-gray-600">
                  <li><Link to="/etude-posturale" className="hover:text-black transition-colors">Études Posturales</Link></li>
                  <li><Link to="/location" className="hover:text-black transition-colors">Location Vélo</Link></li>
                  <li><Link to="/atelier-velo" className="hover:text-black transition-colors">Atelier & Réparation</Link></li>
                  <li><Link to="/lavage-velo" className="hover:text-black transition-colors">Lavage Vélo</Link></li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-black mb-4">Informations</h3>
                <ul className="space-y-2 text-gray-600">
                  <li><a href="#apropos" className="hover:text-black transition-colors">À propos</a></li>
                  <li><a href="#contact" className="hover:text-black transition-colors">Contact</a></li>
                  <li><a href="#mentions-legales" className="hover:text-black transition-colors">Mentions Légales</a></li>
                  <li><a href="#cgv" className="hover:text-black transition-colors">CGV</a></li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-black mb-4">Support</h3>
                <ul className="space-y-2 text-gray-600">
                  <li><a href="#faq" className="hover:text-black transition-colors">FAQ</a></li>
                  <li><a href="#livraison" className="hover:text-black transition-colors">Livraison</a></li>
                  <li><a href="#retours" className="hover:text-black transition-colors">Retours</a></li>
                  <li><a href="#garantie" className="hover:text-black transition-colors">Garantie</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
